import { 
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_USER_BY_EMAIL, 
} from "../actions/types";

const initialState = {
    user: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    // ensure no redux values linger between users ----
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
        return {
            ...initialState,
        }
    // ------------------------------------------------
    case GET_USER_BY_EMAIL:
      return {
        ...state,
        user: action.payload
      };
    default:
      return state;
  }
}